import { AdminReportView } from "@/pages/dashboard/admin/AdminReportView";
import { ReportFiltersView } from "@/pages/dashboard/admin/ReportFiltersView";

export function AdminReportsCompositeView() {
  return (
    <div className="mt-4 grid grid-cols-1 gap-4 [&>*]:min-w-0">
      <ReportFiltersView />
      <AdminReportView />
    </div>
  );
}
